import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';
import {
  betSlipErrorMapping,
  defaultBetSlipErrorConfig,
  isCustomBetSlipErrorCode
} from '@swf/sports/config/bet-slip-errors';
import { isPlaceBetRespCode } from '@swf/sports/types/place-bet';

import { getErrorConfig } from '../utils/getErrorConfig';

const useDismissibleBetSlipError = () => {
  const errorCode = useSelector(select.betSlip.errorCode);
  const errorResponse = useSelector(select.betSlip.errorResponse);
  const siteId = useSelector(select.cms.getSiteId);
  const hasNonAutoDismissibleBetError = useSelector(select.betSlip.hasNonAutoDismissibleBetError);
  const dispatch = useDispatch<Dispatch>();
  const errorConfigParams =
    errorCode && (isPlaceBetRespCode(errorCode) || isCustomBetSlipErrorCode(errorCode))
      ? betSlipErrorMapping[errorCode]
      : undefined;

  const errorConfig =
    errorCode &&
    getErrorConfig({
      config: errorConfigParams ?? defaultBetSlipErrorConfig,
      siteId
    });

  return {
    ...errorConfig,
    isAutoDismissible: errorConfig
      ? errorConfig.isAutoDismissible !== false && !hasNonAutoDismissibleBetError
      : true,
    dismissError: dispatch.betSlip.errorDismissed,
    errorResponse
  };
};

export default useDismissibleBetSlipError;
